"use client"

// components/FlightSearchForm.tsx
import React, { useEffect, useState } from "react";
import { Button } from "../../ui/button";
import { useFormikContext } from "formik";
import { ChevronUpIcon, ChevronDownIcon } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { AirlineSearch } from "@/components/admin/passengersTable/airline-search";
import { MultiAirlineSearch } from "@/components/admin/passengersTable/multi-airline-search";

const FlightSearchForms: React.FC<{initialValues: any}> = ({initialValues}) => {
  const [selectedAirlines, setSelectedAirlines] = useState<{code: string}[]>([]);
  const [isConnectingFlight, setIsConnectingFlight] = useState<boolean>(!initialValues.searchModifiers.isConnectingFlight || false);
  const [fareType, setFareType] = useState<string>(initialValues.searchModifiers.pft || "REGULAR");
  const {setFieldValue} = useFormikContext()
  


  useEffect(()=>{
    // setFieldValue('searchModifiers.isDirectFlight' , isDirectFlight);
    setFieldValue('searchModifiers.isConnectingFlight' ,!isConnectingFlight);
    if (selectedAirlines) {
      setFieldValue('preferredAirline' , selectedAirlines);
    } else {
      setFieldValue('preferredAirline' , []);
    }
  },[isConnectingFlight, selectedAirlines, setFieldValue]);

  const handleRadioChange = (value: string) => {
    setFareType(value);
    setFieldValue('searchModifiers.pft', value);
  };



  return (
    <div className="bg-white/5 backdrop-blur-md rounded-lg py-6 space-y-4 w-full m-auto border border-white/10">
      {/* Modifiers Section */}
      <div className="flex flex-wrap items-center gap-6">
        {/* Airline Selection */}
        <div className="flex items-center gap-2">
           
            <MultiAirlineSearch
            onSelect={(airlines) => setSelectedAirlines(airlines)}
            placeholder="Select Airlines..."
          />
          
        </div>

        {/* Direct Flight Toggle */}
        <div className="flex items-center gap-2">
          <Switch
            id="direct-flight"
            checked={isConnectingFlight}
            className="data-[state=checked]:bg-primary"
            onCheckedChange={() => setIsConnectingFlight((prev) => !prev)}
          />
          <Label htmlFor="direct-flight" className="text-black/80 ">
            Direct Flights Only
          </Label>
        </div>
      </div>

      {/* Fare Types */}
      <div className="flex items-center gap-4">
        <Label className="text-black/80 font-medium">Fare Type</Label>
        <RadioGroup
          value={fareType}
          onValueChange={handleRadioChange}
          className="flex flex-wrap gap-4"
          defaultValue="REGULAR"
        >
          <div className="flex items-center space-x-2">
            <RadioGroupItem
             className="text-primary border-black/30" value="REGULAR" id="regular-fares" />
            <TooltipProvider delayDuration={10}>
              <Tooltip> 
                <TooltipTrigger>
                  <Label htmlFor="regular-fares" className="text-black/80">Regular</Label>
                </TooltipTrigger>
                {/* <TooltipContent side="right" className="max-w-[300px]">
                  <p>Only students above 12 years of age are eligible for special fares and/or additional baggage allowances. Carrying valid student ID cards and student visas (where applicable) is mandatory, else the passenger may be denied boarding or asked to pay for extra baggage.</p>
                </TooltipContent> */}
              </Tooltip>
            </TooltipProvider>
          </div>
          <div className="flex items-center space-x-2">
            <RadioGroupItem className="text-primary border-black/30" value="STUDENT" id="student-fares" />
            <TooltipProvider delayDuration={10}>
              <Tooltip>
                <TooltipTrigger>
                  <Label htmlFor="student-fares" className="text-black/80">Student</Label>
                </TooltipTrigger>
                <TooltipContent side="right" className="max-w-[300px]">
                  <p>Only students above 12 years of age are eligible for special fares and/or additional baggage allowances. Carrying valid student ID cards and student visas (where applicable) is mandatory, else the passenger may be denied boarding or asked to pay for extra baggage.</p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          </div>
          <div className="flex items-center space-x-2">
            <RadioGroupItem className="text-primary border-black/30" value="SENIOR_CITIZEN" id="senior-fares" />
            <TooltipProvider delayDuration={10}>
              <Tooltip>
                <TooltipTrigger>
                  <Label htmlFor="senior-fares" className="text-black/80">Senior Citizen</Label>
                </TooltipTrigger>
                <TooltipContent side="right" className="max-w-[300px]">
                  <p>Only senior citizens above the age of 60 years can avail this special fare. It is mandatory to produce proof of Date of Birth at the airport, without which prevailing fares will be charged.</p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          </div>
        </RadioGroup>
      </div>
    </div>
  );
};

export default FlightSearchForms;
